import { render } from "./PickDeptoMpio.vue?vue&type=template&id=535e0dde"
import script from "./PickDeptoMpio.vue?vue&type=script&lang=ts"
export * from "./PickDeptoMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script